import { SUCCESSFULLY_LOGIN, LOGOUT } from "../actions/actionTypes";

const initialState = {
  token: "",
};

export function auth(state = initialState, action) {
  switch (action.type) {
    case SUCCESSFULLY_LOGIN:
      return {
        ...state,
        token: action.payload.token,
      };
    case LOGOUT:
      return {
        ...state,
        token: "",
      };
    default:
      return state;
  }
}
